'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = require('./required');

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (min, max) {
  return function (value) {
    return !(0, _required2.default)(value) || !/\s/.test(value) && Number(min) <= value && Number(max) >= value;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/between.js
// module id = ./node_modules/vuelidate/lib/validators/between.js
// module chunks = 0